import type { AxiosProgressEvent, CancelToken } from "axios";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IAcademicGroupMember } from "./routeType";

const { getPath } = getApi("academicGroups.member.postBatch");

type IExtractedRouteType =
  IAcademicGroupMember["academicGroupMemberProfileSingleCreate"];

export type IPostBatchAcademicGroupMembers = IPickMutation<IExtractedRouteType>;

// const postBatchAcademicGroupMembers: MutationFunction<
//   IPostBatchAcademicGroupMembers["response"],
//   IPostBatchAcademicGroupMembers["variables"]
// > = ({ academicGroupId, ...data }) => {
//   return axiosClient.post(getPath({ academicGroupId }), data);
// };

// export const usePostBatchAcademicGroupMembers = createMutation({
//   mutationFn: postBatchAcademicGroupMembers,
//   onSuccess: () => {
//     queryClient.invalidateQueries({
//       queryKey: useGetAllMembers.getKey(),
//     });
//   },
// });

export const postBatchAcademicGroupMembers = (academicGroupId: string) =>
  function uploadFileAPI(
    file: File,
    progressCallBack?: (progressEvent: AxiosProgressEvent) => void,
    cancelToken?: CancelToken,
  ): Promise<unknown> {
    const data = new FormData();

    data.append("data", file);

    return axiosClient.post(getPath({ academicGroupId }), data, {
      onUploadProgress(progressEvent) {
        progressCallBack?.(progressEvent);
      },
      cancelToken,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

// TODO:
// queryClient.invalidateQueries({
//   queryKey: useGetAllMembers.getKey(),
// })
